import type { InputHTMLAttributes } from 'react';
import { cn } from '../../../lib/cn';
import { CONTROL_BASE, CONTROL_SIZES } from './controlStyles';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: keyof typeof CONTROL_SIZES;
}

export function Input({ size = 'md', className, ...rest }: InputProps) {
  return <input className={cn(CONTROL_BASE, CONTROL_SIZES[size], className)} {...rest} />;
}
